// /* Hair Dyes mega menu: show the first N products per collection, then a
//    "Shop All Collection" link that expands to reveal the rest.
//    Target: #MegaMenu-Content-4. Include once, e.g. in header.liquid:
//      <script src="{{ 'hair-dyes-more.js' | asset_url }}" defer="defer"></script>
// */
// (function () {
//   var LIMIT = 6; // products shown before "Shop All Collection"

//   function init() {
//     var menu = document.getElementById('MegaMenu-Content-4');
//     if (!menu) return;

//     var columns = menu.querySelectorAll('#MegaMenu-Content-4 > ul.mega-menu__list > li');
//     columns.forEach(function (col) {
//       var list = col.querySelector('ul.list-unstyled');
//       if (!list || list.dataset.hdInit) return;      // guard against double-run
//       list.dataset.hdInit = '1';

//       var items = Array.prototype.slice.call(list.children);
//       if (items.length <= LIMIT) return;

//       var hidden = items.slice(LIMIT);
//       hidden.forEach(function (li) { li.classList.add('hd-hidden'); });

//       var heading = col.querySelector('a.mega-menu__link--level-2');
//       var url = heading ? heading.getAttribute('href') : '#';

//       var moreLi = document.createElement('li');
//       moreLi.className = 'hd-shopall';
//       moreLi.innerHTML =
//         '<a href="' + url + '" class="hd-shopall__link">' +
//           'Shop All Collection <span class="hd-arrow" aria-hidden="true"></span>' +
//         '</a>';
//       list.appendChild(moreLi);

//       moreLi.querySelector('a').addEventListener('click', function (e) {
//         e.preventDefault();
//         e.stopPropagation();
//         hidden.forEach(function (li) { li.classList.remove('hd-hidden'); });
//         // Move focus to a still-present element BEFORE removing the link.
//         // Removing the focused link would send focus to <body>, and Dawn's
//         // header-menu closes the whole dropdown on that focusout.
//         var focusTarget = (hidden[0] && hidden[0].querySelector('a')) || heading;
//         if (focusTarget) focusTarget.focus({ preventScroll: true });
//         moreLi.remove();
//       });
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();

/* Hair Dyes mega menu: show the first N products per collection, then a
   "Shop All Collection" link that expands to reveal the rest.
   Target: #MegaMenu-Content-4. Include once, e.g. in header.liquid:
     <script src="{{ 'hair-dyes-more.js' | asset_url }}" defer="defer"></script>
*/
(function () {
  var LIMIT = 6; // products shown before "Shop All Collection"

  function init() {
    var menu = document.getElementById('MegaMenu-Content-4');
    if (!menu) return;

    var columns = menu.querySelectorAll('#MegaMenu-Content-4 > ul.mega-menu__list > li');
    columns.forEach(function (col) {
      var list = col.querySelector('ul.list-unstyled');
      if (!list || list.dataset.hdInit) return;      // guard against double-run
      list.dataset.hdInit = '1';

      var items = Array.prototype.slice.call(list.children);

      // Temporary Hair Color Spray should show only 5 products initially
      var currentLimit = col === columns[1] ? 5 : LIMIT;

      if (items.length <= currentLimit) return;

      var hidden = items.slice(currentLimit);
      hidden.forEach(function (li) { li.classList.add('hd-hidden'); });

      var heading = col.querySelector('a.mega-menu__link--level-2');
      var url = heading ? heading.getAttribute('href') : '#';

      var moreLi = document.createElement('li');
      moreLi.className = 'hd-shopall';
      moreLi.innerHTML =
        '<a href="' + url + '" class="hd-shopall__link">' +
          'Shop All Collection <span class="hd-arrow" aria-hidden="true"></span>' +
        '</a>';
      list.appendChild(moreLi);

      moreLi.querySelector('a').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        hidden.forEach(function (li) { li.classList.remove('hd-hidden'); });
        // Move focus to a still-present element BEFORE removing the link.
        // Removing the focused link would send focus to <body>, and Dawn's
        // header-menu closes the whole dropdown on that focusout.
        var focusTarget = (hidden[0] && hidden[0].querySelector('a')) || heading;
        if (focusTarget) focusTarget.focus({ preventScroll: true });
        moreLi.remove();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();